import { EOfferStages } from 'entities/Offer';
import { i18n } from 'i18n';
import { TKeyLabel } from 'shared/typings/types/keyLabel.type';

export const OFFER_STAGES = {
	[EOfferStages.OVERVIEW]: i18n.t('Overview'),
	[EOfferStages.PROPOSALS]: i18n.t('Proposals'),
	[EOfferStages.ACTIVE]: i18n.t('Active'),
	[EOfferStages.UNDER_REVIEW]: i18n.t('Under review'),
	[EOfferStages.COMPLETED]: i18n.t('Completed'),
};

export const OFFER_STAGES_TABS: TKeyLabel[] = Object.entries(OFFER_STAGES).map(([key, value]) => ({
	key: key,
	label: value,
}));
